import React from 'react'

import { InsuranceAdditionalDetailsType } from '../utils/insurance'

import LahiTapiolaForm from './DirectCompensationInsurance/LahiTapiolaForm'
import PohjolaForm from './DirectCompensationInsurance/PohjolaForm'
import OccupationalAccidentForm from './OccupationalAccidentForm'
import TrafficAccidentForm from './TrafficAccidentForm'

// extend type as needed

interface Props {
  additionalInfoForm: string
  onSubmitDetails(details?: InsuranceAdditionalDetailsType): void
  onContinueAsSelfPaying(): void
  onBack(): void
}

const InsuranceAdditionalDetails: React.FC<React.PropsWithChildren<Props>> = ({
  additionalInfoForm,
  onSubmitDetails,
  onBack,
  onContinueAsSelfPaying,
}) => {
  if (additionalInfoForm === 'traffic_accident') {
    return <TrafficAccidentForm onSubmit={onSubmitDetails} onBack={onBack} />
  }

  if (additionalInfoForm === 'occupational_accident') {
    return <OccupationalAccidentForm onSubmit={onSubmitDetails} onBack={onBack} />
  }

  if (additionalInfoForm === 'lahitapiola') {
    return (
      <LahiTapiolaForm
        onSubmit={onSubmitDetails}
        onContinueAsSelfPaying={onContinueAsSelfPaying}
        onBack={onBack}
      />
    )
  }

  if (
    ['pohjola', 'pohjola_company_form', 'pohjola_company_form_accident'].includes(
      additionalInfoForm
    )
  ) {
    return (
      <PohjolaForm
        additionalInfoForm={additionalInfoForm}
        onSubmit={onSubmitDetails}
        onContinueAsSelfPaying={onContinueAsSelfPaying}
        onBack={onBack}
      />
    )
  }

  return null
}

export default InsuranceAdditionalDetails
